/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Trend direction for risk indicators */
export enum TrendDirection {
  Increasing,
  Decreasing,
  Stable,
  Unknown,
}

export type TrendDirectionArgs = TrendDirection;

export function getTrendDirectionEncoder(): FixedSizeEncoder<TrendDirectionArgs> {
  return getEnumEncoder(TrendDirection);
}

export function getTrendDirectionDecoder(): FixedSizeDecoder<TrendDirection> {
  return getEnumDecoder(TrendDirection);
}

export function getTrendDirectionCodec(): FixedSizeCodec<
  TrendDirectionArgs,
  TrendDirection
> {
  return combineCodec(getTrendDirectionEncoder(), getTrendDirectionDecoder());
}
